import moment from "moment";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Request } from "../../../../types/models/manufacturingRoutes.model.type";
import { MyFilterRequestSumary } from "../../../../types/request/myRequest.type";
import { FilterOptionsMyRequestSumary, MyRequestSumaryState } from "../../../../types/states/myRequestSumary.state.type";

const initialState: MyRequestSumaryState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  filterOptions: {
    rangeDate: [moment().startOf("month"), moment()],
    filterProcessAndRegistered: true,
  },
  request: undefined,
};

const myRequestSumarySlice = createSlice({
  name: "myRequestSumary",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.selectedItem = undefined;
      state.data = [];
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<Request[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.recordDetailId === state.selectedItem!.recordDetailId);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetFilterOptions: (state, { payload }: PayloadAction<FilterOptionsMyRequestSumary>) => {
      state.filterOptions = payload;
    },
    rxSetRequest: (state, { payload }: PayloadAction<MyFilterRequestSumary>) => {
      state.request = payload;
    },
    rxResetFilter: (state) => {
      state.filterOptions = {
        rangeDate: [moment().startOf("month"), moment()],
        filterProcessAndRegistered: true,        
      };
    },    
  },
});

export const {
  rxErrorFetchingData,
  rxResetFilter,
  rxSetFilterOptions,
  rxSetRequest,  
  rxStartFetching,
  rxSuccessFetchingData,
} = myRequestSumarySlice.actions;
export const myRequestSumarySelector = (state: { myRequestSumary: MyRequestSumaryState }) => state.myRequestSumary;
export default myRequestSumarySlice.reducer;
